/**
 * Template string resources file
 *
 * For centrally-managed string resources and localisation
 */
export const initial_timeline_row_name = 'Story';
